export enum SolIconBubbleVariantEnum {
  default = 'default',
  transparent = 'transparent',
  white = 'white',
  accent = 'accent',
  success = 'success',
  danger = 'danger',
  warning = 'warning',
}

export type SolIconBubbleVariant = `${SolIconBubbleVariantEnum}`;
